import React, { Fragment, Component } from 'react';
import { Field } from 'react-final-form';
import translate from 'counterpart';
import { path } from 'ramda';

import Input from 'components/common/form/Input';
import ListenerField from 'components/common/form/ListenerField';

export default class LegalInfoFields extends Component {
    render() {
        const { user } = this.props;

        return (
            <div className="card">
                <div className="card-body">
                    <ListenerField
                        listenFieldName='kadrsyst'
                    >
                        { ({ kadrsyst }) => {
                            const selected = kadrsyst && !!kadrsyst.department;
                            const isChief = !!(user.id === path(['departchiefkey'], kadrsyst));

                            return user ? (
                                <Fragment>
                                    <Input
                                        input={{
                                            value: selected ? (
                                                isChief ? translate('request.legalRoleChief') : translate('request.legalRoleReplace')
                                            ) : '',
                                        }}
                                        disabled
                                        label={{ content: 'request.legalRole' }}
                                    />
                                    { selected && !isChief && (
                                        <Field
                                            name='kadrsyst.chief'
                                            component={Input}
                                            disabled
                                            label={{ content: 'request.legalChief' }}
                                        />
                                    )}
                                </Fragment>
                            ) : null;
                        }}
                    </ListenerField>
                </div>
            </div>
        );
    }
}
